import { render } from "./AdminClaimDetails.vue?vue&type=template&id=8fe92504"
import script from "./AdminClaimDetails.vue?vue&type=script&lang=js"
export * from "./AdminClaimDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__